import { provideContext } from './chunk-OJRMMG75.js';
import { scoped, root, getScope, isFunction, effect, onDispose, createScope, tick, signal } from '@maverick-js/signals';

// src/element/internal.ts
var CONNECT = /* @__PURE__ */ Symbol(0);
var PROPS = /* @__PURE__ */ Symbol(0);
var METHODS = /* @__PURE__ */ Symbol(0);
function createComponent(Component, init) {
  const instance = new ComponentInstance(Component, init);
  return scoped(() => new Component(instance), instance.c);
}
var ComponentInstance = class {
  constructor(Component, init = {}) {
    this.m = null;
    this.h = null;
    this.G = false;
    this.j = false;
    this.e = {};
    this.p = {};
    this.f = {};
    // these props cause type issues - don't type them.
    this.A = null;
    this.k = null;
    this.d = [];
    this.o = [];
    this.i = [];
    this.x = [];
    root((dispose) => {
      this.c = getScope();
      this.H = dispose;
      if (init.scope)
        init.scope.append(this.c);
      const store = Component.el.store;
      if (store) {
        this.k = store.create();
        this.A = new Proxy(this.k, {
          get: (_, prop) => this.k[prop]()
        });
        provideContext(store, this.k);
      }
      const props = Component.el.props;
      if (props) {
        this.f = createInstanceProps(props);
        if (init.props) {
          for (const prop of Object.keys(init.props)) {
            if (prop in props) {
              const value = init.props[prop];
              if (isFunction(value)) {
                effect(() => void this.f[prop].set(value()));
              } else {
                this.f[prop].set(value);
              }
            }
          }
        }
      }
      if (init.props?.innerHTML) {
        this.G = true;
      }
      onDispose(this.y.bind(this));
    });
  }
  I() {
    if (!this.h)
      return null;
    if (!this.z) {
      scoped(() => {
        this.z = createScope();
      }, this.c);
    }
    return scoped(() => this.h(), this.z);
  }
  y() {
    if (this.j)
      return;
    this.j = true;
    for (const destroy of this.x) {
      scoped(() => destroy(this.m), this.c);
    }
    this.m?.destroy();
    this.d.length = 0;
    this.o.length = 0;
    this.i.length = 0;
    this.x.length = 0;
    tick();
    this.H();
    this.m = null;
    this.h = null;
  }
};
function createInstanceProps(defs) {
  const props = {};
  for (const name of Object.keys(defs)) {
    const def = defs[name];
    props[name] = signal(def.value, def);
  }
  return props;
}

export { CONNECT, ComponentInstance, METHODS, PROPS, createComponent };
